/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ICycleDay } from 'app/shared/model/cycle-day.model';

export interface IMucus {
  id?: string;
  feeling?: number | null;
  texture?: number | null;
  value?: number | null;
  comments?: string | null;
  active?: boolean | null;
  draft?: boolean;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  isPresent?: boolean | null;
  cycleDay?: ICycleDay | null;
}

export const defaultValue: Readonly<IMucus> = {
  active: false,
  draft: false,
  isPresent: false,
};
